module.exports = __webpack_public_path__ + "static/media/avatars_all_21.e9c25912.png";